module.exports = __webpack_public_path__ + "img/AL273HS-2-EN.90c93dbe.jpg";